import React from "react";
import * as SubframeCore from "@subframe/core";
import { Button } from "subframe/components/Button";
import { IconButton } from "subframe/components/IconButton";

interface EscalationAlertProps {
  title: string;
  description: string;
  buttonText: string;
  onViewTicket: () => void;
  onClose: () => void;
}

export const EscalationAlert: React.FC<EscalationAlertProps> = ({
  title,
  description,
  buttonText,
  onViewTicket,
  onClose,
}) => {
  return (
    <div className="flex w-full flex-col items-start gap-2 sm:gap-3 rounded-md border border-solid border-error-100 bg-error-50 px-3 sm:px-4 py-3 sm:py-4">
      <div className="flex w-full flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <SubframeCore.Icon
          className="text-subheader font-subheader text-error-800 flex-shrink-0"
          name="FeatherInfo"
        />
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
          <span className="w-full whitespace-pre-wrap text-body-bold font-body-bold text-error-900">
            {title}
          </span>
          <span className="w-full whitespace-pre-wrap text-label font-label text-error-800">
            {description}
          </span>
        </div>
        <div className="flex w-full sm:w-auto flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
          <Button
            disabled={false}
            variant="destructive-primary"
            size="medium"
            icon={null}
            iconRight={null}
            loading={false}
            onClick={onViewTicket}
            className="w-full sm:w-auto"
          >
            {buttonText}
          </Button>
          <div className="flex items-center justify-end gap-1">
            <IconButton
              size="medium"
              icon="FeatherX"
              onClick={onClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
}; 